import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import LeadsAdvertisementsTable from './components/LeadsAdvertisementsTable'
import { useSearchAdvertisementsMutation } from '../../../services'
import { UspConfigurationAdvertisementViewResult } from '../../../models'
import AddEditAdvertisementModal from './components/AddEditAdvertisementModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsLeadsAdvertisements = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchAdvertisements, { data, isLoading }] = useSearchAdvertisementsMutation()
  const [advertisementData, setAdvertisementData] = useState<UspConfigurationAdvertisementViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchAdvertisements({
      uspConfigurationAdvertisementView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setAdvertisementData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Lead Sources'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
            Add new
          </Button>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <LeadsAdvertisementsTable
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                      handleOpenModal={handleOpenModal}
                      loading={isLoading}
                      data={advertisementData}
                      setData={setAdvertisementData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditAdvertisementModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationAdvertisementViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsLeadsAdvertisements
